"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDoctorOutput = instanceOfDoctorOutput;
exports.DoctorOutputFromJSON = DoctorOutputFromJSON;
exports.DoctorOutputFromJSONTyped = DoctorOutputFromJSONTyped;
exports.DoctorOutputToJSON = DoctorOutputToJSON;
var Metadata_1 = require("./Metadata");
var Doctor_1 = require("./Doctor");
/**
 * Check if a given object implements the DoctorOutput interface.
 */
function instanceOfDoctorOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function DoctorOutputFromJSON(json) {
    return DoctorOutputFromJSONTyped(json, false);
}
function DoctorOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Doctor_1.DoctorFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function DoctorOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Doctor_1.DoctorToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
